<template>
    <div class="container">
        <img class="header" :src="imgLink" alt="banner图片" />
        <div class="year-banner" @click="showSelect">
            <p>{{ selectYear }}</p>
        </div>
        <div class="list">
            <ul>
                <li v-for="item in list" :key="item.id">
                    <div class="title">
                        <span class="sub-title">{{ item.title }}</span>
                        <span>{{ item.day }}</span>
                    </div>
                    <p class="desc">
                        {{ item.description }}
                        <router-link
                            :to="{
                                name: `${module}Detail`,
                                query: {
                                    id: item.id
                                }
                            }"
                        >
                            [查看详情]
                        </router-link>
                    </p>
                </li>
            </ul>
            <page-turn :pageSum="pageSum" @on-turn="onTurn"></page-turn>
        </div>
        <comPicker
            :showPicker="showYearPicker"
            :pickerTitle="'年份选择'"
            :pickerList="pickerList"
            :selectPicker="selectYear"
            @closePicker="close"
            @confirmPicker="confirm"
        ></comPicker>
    </div>
</template>

<script>
import ajax from '@/api/ajax'
import comPicker from '@/components/comSelector'
import pageTurn from '@/components/page-turn'
import { coverMap, ajaxMap } from './config'
export default {
    name: 'YearList',
    components: {
        comPicker,
        pageTurn
    },
    data() {
        return {
            list: [],
            selectYear: '',
            showYearPicker: false,
            pageNo: 1,
            pageSize: 5,
            pageSum: 1,
            module: '',
            pickerList: [],
            coverMap
        }
    },
    computed: {
        imgLink() {
            return require(`@/assets/images/yearContent/${this.coverMap.get(this.module)}`)
        }
    },
    async created() {
        this.module = this.$route.meta.module || ''
        const startList = await this.getList(undefined, 1, 1, 'day:asc')
        const endList = await this.getList(undefined, 1, 1, 'day:desc')
        const newList = [...endList, ...startList]
        const data = [...new Set(newList.map(item => item.day.slice(0, 4)))]
        this.pickerList = this.expandYearRange(data.sort((a, b) => b - a))
        this.selectYear = data[0]
        this.conditionList(true)
    },
    methods: {
        expandYearRange(range) {
            const startYear = range[0]
            const endYear = range[1]
            const yearArray = []
            for (let year = startYear; year >= endYear; year--) {
                yearArray.push(year)
            }
            return yearArray
        },
        /**
         * 获取新闻列表
         * @return 返回新闻列表
         * @param selectYear 选择的某一年份
         * @param pageNo 第几页
         * @param pageSize 一页几个
         */
        async getList(selectYear, pageNo, pageSize, sort) {
            this.$loading('加载中')
            const params = {}
            if (selectYear) {
                params['filters[day][$lt]'] = `${Number(selectYear) + 1}-01-01`
                params['filters[day][$gte]'] = `${selectYear}-01-01`
            }
            if (pageNo && pageSize) {
                params['pagination[start]'] = (pageNo - 1) * pageSize
                params['pagination[limit]'] = pageSize
            }
            params.sort = sort || 'day:desc'
            const result = await ajax[ajaxMap.get(this.module)]({
                params
            })
            this.$loading()
            if (result) {
                return result
            } else {
                return []
            }
        },
        async getListCount(selectYear) {
            const params = { returnMeta: true }
            if (selectYear) {
                params['filters[day][$lt]'] = `${Number(selectYear) + 1}-01-01`
                params['filters[day][$gte]'] = `${selectYear}-01-01`
            }
            const {
                meta: {
                    pagination: { total }
                }
            } = await ajax[ajaxMap.get(this.module)]({
                params
            })
            return total || 0
        },
        async conditionList(changeYear) {
            if (changeYear) {
                const totalNums = await this.getListCount(this.selectYear)
                this.pageSum = Math.ceil(totalNums / this.pageSize)
            }
            this.list = await this.getList(this.selectYear, this.pageNo, this.pageSize)
            window.scrollTo(0, 0)
        },
        showSelect() {
            this.showYearPicker = true
        },
        confirm(val) {
            this.showYearPicker = false
            this.selectYear = val
            this.pageNo = 1
            this.conditionList(true)
        },
        close() {
            this.showYearPicker = false
        },
        onTurn(data) {
            this.pageNo = Number(data.page)
            this.conditionList()
        },
        toDetail(id) {
            this.$router.push({
                name: `${this.module}Detail`,
                query: {
                    id
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.container {
    .header {
        width: 100%;
        display: block;
    }
    .year-banner {
        height: 120px;
        background: #f1f1f1;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        p {
            font-size: 36px;
            color: #333333;
            font-weight: bold;
            line-height: 60px;
            cursor: pointer;
        }
    }
    .selector-roll {
        position: absolute;
        z-index: 999;
        width: 100%;
        top: 0;
        bottom: 0;
        max-width: 7.5rem;
        color: #000;
        background: rgba(0, 0, 0, 0.5);
        .selector-main {
            position: fixed;
            bottom: 0;
            width: 100%;
            min-height: 5rem;
            display: flex;
            flex-flow: column nowrap;
            background: #fff;
            border-radius: 0.08rem 0.08rem 0 0;
            .selector-top {
                position: relative;
                text-indent: 1ch;
                font-size: 0.3rem;
                color: #111111;
                font-weight: 800;
                padding: 0.34rem 0.1rem;
                border-bottom: 0.04rem solid #f8f9fa;
                div {
                    position: relative;
                    .icon-close {
                        position: absolute;
                        top: -0.05rem;
                        right: 0.2rem;
                        width: 0.5rem;
                        height: 0.5rem;
                        &:before {
                            position: absolute;
                            top: 50%;
                            content: '';
                            display: block;
                            height: 5px;
                            width: 0.36rem;
                            background: #000;
                            transform: rotate(45deg);
                        }
                        &:after {
                            position: absolute;
                            top: 50%;
                            content: '';
                            display: block;
                            height: 5px;
                            width: 0.36rem;
                            background: #000;
                            transform: rotate(-45deg);
                        }
                    }
                }
            }
            .selector-content {
                padding: 0.2rem 0.3rem 0;
                .selector-area {
                    position: relative;
                    height: 4rem;
                    >>> .picker {
                        position: relative;
                        width: 100%;
                        z-index: 1;
                    }
                    >>> .picker-item {
                        color: #707274;
                        &.picker-selected {
                            color: #dc1e32;
                        }
                    }
                }
            }
            .selector-bottom {
                z-index: 99;
                background: #fff;
                .btn-confirm {
                    padding: 0.2rem.5rem;
                    >>> span {
                        display: inline-block;
                        width: 100%;
                        border-radius: 0.48rem;
                        text-align: center;
                        color: #fff;
                        font: bold 0.34rem/3 YaHei;
                        letter-spacing: 0.5rem;
                        text-indent: 0.5rem;
                        background: rgba(0, 0, 0, 0.3);
                    }
                    &.active {
                        >>> span {
                            background: #dc1e32;
                            color: #ffffff;
                        }
                    }
                }
            }
        }
    }
    ::-webkit-scrollbar {
        display: none;
    }
    .list {
        padding: 0 20px;
        margin-top: 100px;
        ul {
            li {
                padding: 40px 30px;
                border: 2px solid #dbdada;
                margin-bottom: 50px;
                .title {
                    color: #333333;
                    .sub-title {
                        font-size: 36px;
                        color: #333333;
                        display: block;
                    }
                    span {
                        color: #000;
                        font-size: 28px;
                        display: block;
                        margin-top: 20px;
                    }
                }
                .desc {
                    font-size: 28px;
                    color: #333333;
                    line-height: 48px;
                    margin-top: 20px;
                    a {
                        color: #dc1e32;
                    }
                }
            }
        }
    }
    .fade-enter-active,
    .fade-leave-active {
        bottom: 0;
        opacity: 1;
        transition: all 0.3s;
    }
    .fade-enter,
    .fade-leave-to {
        opacity: 0;
        bottom: -100vh;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/year-content/list.vue